/**
 * ModalTrigger.js — wires up any [data-modal-target="id"] element to open the
 * modal #id. Modal must use the .edit-profile-modal shell (backdrop/close-btn
 * classes, .is-open toggle) — same convention as EditProfileModal.js.
 */
export default class ModalTrigger {
  constructor(selector = '[data-modal-target]') {
    this.triggers = document.querySelectorAll(selector);
    if (!this.triggers.length) return;

    this.triggers.forEach((trigger) => this._bind(trigger));
  }

  _bind(trigger) {
    const modal = document.getElementById(trigger.dataset.modalTarget);
    if (!modal) return;

    const backdrop   = modal.querySelector('.edit-profile-backdrop');
    const closeBtns  = modal.querySelectorAll('.edit-profile-close-btn, [data-modal-cancel]');
    const firstInput = modal.querySelector('input, select, textarea');
    const form       = modal.querySelector('form');

    const open = () => {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(() => firstInput?.focus(), 50);
    };

    const close = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      open();
    });

    backdrop?.addEventListener('click', close);
    closeBtns.forEach((btn) => btn.addEventListener('click', close));

    form?.addEventListener('submit', (e) => {
      e.preventDefault();
      close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }
}
